<div class="map-nav" fxLayout="column" fxLayoutAlign="end end"
     [ngClass]="vm.fabMargin$|async">
  <button mat-fab class="fab"
          (click)="fabClicked()"
          [style.background-color]='vm.primaryColor$|async'
          aria-label="">
    <mat-icon>{{vm.fabIcon$|async}}</mat-icon>
  </button>
</div>
